<template>
	<BaseModal
		ref="gridBaseModalRef"
		full-screen
		:header-title="headerTitle"
		class="gallery-grid-modal"
		@open="onOpen"
	>
		<GalleryGrid
			v-if="galleryItems.length > 0"
			ref="galleryGridRef"
			:items="galleryItems"
			@item-click="openGalleryModal"
			@item-arrows-navigation="onArrowNavigation"
		/>
	</BaseModal>

	<GalleryModalNew
		ref="galleryModalRef"
		:elements="galleryItems"
		:initial-index="activeIndex"
		:header-title="headerTitle"
	/>
</template>

<script lang="ts" setup>
import GalleryGrid from '../GalleryGrid/GalleryGrid.vue';
import GalleryModalNew from './GalleryModalNew.vue';
import { nextTick, ref, useTemplateRef } from 'vue';
import type { GalleryElement } from '@/interfaces/components/galleryElement';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import { useBaseModal } from 'src/storybook/src/composables/useBaseModal';

interface Props {
	galleryItems: GalleryElement[];
	headerTitle?: string;
	focusedIndex?: number;
}

const props = withDefaults(defineProps<Props>(), {
	headerTitle: '',
	focusedIndex: 0,
});

const [openGalleryGridModal] = useBaseModal('gridBaseModalRef');

const galleryModalRef = useTemplateRef('galleryModalRef');
const galleryGridRef = useTemplateRef('galleryGridRef');
const activeIndex = ref(0);

const openGalleryModal = (item: GalleryElement, index: number) => {
	activeIndex.value = index;
	galleryModalRef.value?.openModal();
};

const onOpen = async () => {
	await nextTick(() => {
		galleryGridRef.value?.focusElement(props.focusedIndex);
	});
};
const onArrowNavigation = (index: number) => {
	activeIndex.value = index;
};

defineExpose({
	openGalleryGridModal,
});
</script>

<style lang="scss" scoped>
.gallery-grid-modal {
	width: 100%;
}
</style>
